var exports = {
  "uW": "x7be19a29--67b3d8--section",
  "kL": "x7be19a29--67b3d8--container",
  "Y$": "x7be19a29--67b3d8--container--first",
  "p_": "x7be19a29--67b3d8--list",
  "om": "x7be19a29--67b3d8--block",
  "jW": "x7be19a29--67b3d8--photo",
  "zH": "x7be19a29--67b3d8--details",
  "DD": "x7be19a29--67b3d8--title",
  "O5": "x7be19a29--67b3d8--offers",
  "fi": "x7be19a29--67b3d8--column",
};

module.exports = exports;
